import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from '@app/app.module';
import {environment} from '@env/environment';
import {LicenseManager} from "ag-grid-enterprise";

if (environment.production) {
  enableProdMode();
}

// ag-grid license key
LicenseManager.setLicenseKey(
  "CompanyName=SHI International " +
  "Corp._on_behalf_of_Agilent Technologies, Inc.,LicensedApplication=CID Hub," +
  "LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=6," +
  "LicensedProductionInstancesCount=1,AssetReference=AG-034651," +
  "SupportServicesEnd=9_November_2023_[v2]_MTY5OTQ4ODAwMDAwMA==58609fda9ebbf0c5cb66fa4948781c04"
);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
